var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWriter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#285491",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M21.743 28.39a1.333 1.333 0 0 1-1.886 0l-2.114-2.114a1.333 1.333 0 0 1 0-1.885l7.448-7.448a1.333 1.333 0 0 1 1.885 0l2.115 2.114a1.333 1.333 0 0 1 0 1.886z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#285491",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "m24.8 17.333-1.833-9.165a1.33 1.33 0 0 0-.995-1.035L5.113 2.704a1.333 1.333 0 0 0-1.609 1.61l4.43 16.858a1.33 1.33 0 0 0 1.034.995L18.134 24M3.867 3.067l9.714 9.714"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#285491",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.667,
  d: "M15.467 17.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"
})));
export { SvgWriter as ReactComponent };
export default __webpack_public_path__ + "0487b814f9194caa9deda827d0e05090.svg";